import { Button, DatePicker, Form, Modal, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getAllMaster } from "../../../redux/rtk/features/masters/masterSlice";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { EmployeeCompanyOfficeHistorySetup } from "../../../redux/rtk/features/payment/paymentSlice";
import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";
import { buildCompanyOfficeSelectOptions } from "../../../utils/companyOfficeLabel";

const SEARCHABLE_SELECT_PROPS = {
  showSearch: true,
  optionFilterProp: "label",
  filterOption: (input, option) =>
    String(option?.label ?? "")
      .toLowerCase()
      .includes(input.trim().toLowerCase()),
};

const CompanyHistoryAddSinglePopup = ({ list, setLoading }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { id } = useParams();
  const masterData = useSelector((state) => state.masters.masters);

  const officeOptions = useMemo(
    () => buildCompanyOfficeSelectOptions(masterData),
    [masterData]
  );

  useEffect(() => {
    dispatch(getAllMaster());
  }, [dispatch]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await dispatch(
        EmployeeCompanyOfficeHistorySetup({
          CompanyOfficeId: values.CompanyOfficeId,
          EffectedFrom: values.EffectedFrom,
          EffectedTo: values.EffectedTo,
          CompanyOfficeHistoryId: 0,
          EmployeeId: id,
          DataStatus: 1,
        })
      );
      if (response.payload.message === "success") {
        dispatch(loadSingleStaff(id));
        setIsModalOpen(false);
        form.resetFields();
      }
    } catch (error) {
      // console.error("Error adding company office history:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="primary" onClick={showModal} className="mb-4">
        Add New Office
      </Button>
      <Modal
        title="Add Company Office"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          name="addCompanyOfficeHistory"
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            label="Office"
            name="CompanyOfficeId"
            rules={[{ required: true, message: "Please select an office!" }]}
          >
            <Select
              placeholder="Select office"
              allowClear
              {...SEARCHABLE_SELECT_PROPS}
              options={officeOptions}
            />
          </Form.Item>
          <Form.Item
            label="Effective From"
            name="EffectedFrom"
            rules={[
              { required: true, message: "Please enter the effective date!" },
            ]}
          >
            <DatePicker className="w-full" />
          </Form.Item>
          <Form.Item label="Effective To" name="EffectedTo">
            <DatePicker className="w-full" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Add
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CompanyHistoryAddSinglePopup;
